export const WIDGET = Symbol.for("Widget");